import { Component, Input, OnInit } from '@angular/core';
import { HopperStatus } from '@model/product/smartfeed/smartfeed.model';

@Component({
  selector: 'app-smartfeed-food-status',
  templateUrl: './smartfeed-food-status.component.html',
  styleUrls: ['./smartfeed-food-status.component.scss'],
})
export class SmartfeedFoodStatusComponent implements OnInit {
  @Input()
  foodStatus: HopperStatus;

  constructor() {}

  ngOnInit() {}

  getStatus(foodStatus: HopperStatus) {
    switch (foodStatus) {
      case HopperStatus.GOOD:
        return 'Good';
      case HopperStatus.EMPTY:
        return 'Empty';
      case HopperStatus.LOW:
        return 'Low';
      case HopperStatus.OTHER:
        return 'Unknown';
    }
  }
}
